<template>
  <div class="tag-dropdown-wrapper">
    <a v-if="resource" @click.prevent="openTagManager(resource)" href="#" class="btn btn-outline-primary add-button"><div class="fa fa-plus"></div></a>
    <a v-else @click.prevent="openTagManager(resource)" href="#" class="btn btn-secondary btn-sm" v-bind:class="{'btn-primary': selectedResources.length > 0, 'disabled': selectedResources.length === 0}"><div class="fa fa-tag"></div> {{ $t('tags_manager.add_tags') }}</a>
    <div v-if="tagDropDown" class="tag-dropdown" v-click-outside="closeTagManager">
      <div class="search-wrapper">
        <input v-model="tag_search" v-on:keydown.enter="addTag()"
          type="text" ref="searchTag"
          :placeholder="tags.length === 0 ? $t('tags_manager.create_a_tag') : $t('tags_manager.search_tag')"
          class="form-control"/>
      </div>
      <div class="selectable-tags-wrapper">
        <div v-if="tag_search.length > 0 && !exactMatch"
             @click="addTag()" class="selectable-tag">
          <b><i class="fa fa-plus"></i> {{ $t('tags_manager.create_tag') }}:</b> {{tag_search }}
        </div>
        <div v-for="tag in filteredTags()" @click="toggleTag(tag)"
             v-bind:class="{'selected': selectedTags.indexOf(tag.id) !== -1}"
             class="selectable-tag">
          <i class="fa fa-tag"></i>
          {{ tag.name }}
        </div>
      </div>
      <div @click="submitTags" class="btn btn-primary btn-sm">
        {{ $t('products.list.submit') }}
      </div>
      <div @click="tagDropDown=false"
         class="btn btn-outline-primary btn-sm">
        {{ $t('products.list.cancel') }}
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['selectedResources', 'resource', 'resourceType', 'organizationId'],
    data() {
      return {
        tagDropDown: false,
        selectedTags: [],
        tag_search: "",
        exactMatch: false,
      }
    },
    computed: {
      tags() {
        return this.lists.sharedTags || []
      }
    },
    methods: {
      addTag() {
        if (this.tag_search.length > 0 && !this.exactMatch) {
          this.store.createSharedTag({ name: this.tag_search, organization_id: this.organizationId }).then(({data}) => {
            this.loadTags()

            this.tag_search = ''
            this.selectedTags.push(data.id)
            this.$toastr.success(this.$t('products.list.tag_created'))
          })
        }
      },
      loadTags() {
        return this.listStore.getSharedTags(this.organizationId)
      },
      openTagManager(resource) {
        let ids = resource && resource.tags ? resource.tags.map((x) => x.id) : []
        if (this.$props.resource || this.$props.selectedResources.length > 0) {
          this.loadTags().then(() => {
            this.tag_search = ''
            this.tagDropDown = true
            this.selectedTags = ids
            this.reOrderTags(this.selectedTags)
            this.$nextTick(() => {
              this.$refs.searchTag.focus()
            })
          })
        }
      },
      closeTagManager() {
        if (this.tagDropDown)   {
          this.tagDropDown = false
        }
      },
      reOrderTags(selected) {
        this.tags.slice().sort(function (a, b) {
          return selected.indexOf(a.id) !== -1 && selected.indexOf(b.id) === -1 ? -1 : a.name.localeCompare(b.name)
        })
      },
      submitTags() {
        let formData = {
          tag_ids: this.selectedTags,
          record_ids: this.$props.selectedResources,
          record_id: this.$props.resource && this.$props.resource.id,
          organization_id: this.organizationId
        }
        this.store.connectSharedTags(formData).then(() => {
          this.$emit('reload-list')
          this.tagDropDown = false
          this.store.sendMetrics({name: 'connect_tag_shared_with_record', params: this.$route.params, path: this.$route.fullPath})

        })
      },
      toggleTag(tag) {
        let selected = this.selectedTags
        selected.indexOf(tag.id) === -1 ? selected.push(tag.id) : selected.splice(this.selectedTags.indexOf(tag.id), 1)
      },
      filteredTags() {
        let search_term = this.tag_search
        this.exactMatch = this.tags.filter((t) => t.name.toLowerCase().indexOf(search_term.toLowerCase()) === 0 && t.name.length === search_term.length).length > 0
        return search_term.length > 0 ? this.tags.filter((t) => t.name.toLowerCase().indexOf(search_term.toLowerCase()) !== -1) : this.tags
      }
    }
  }
</script>

<style lang="sass">
  @import "../../../styles/tag_manager.sass"
</style>
